import React from 'react';
import { createStyleSheet, Divider, useStyleSheet, View, Focusable, Checkbox } from '@gopeerproject/ui-kit';
import { Cell } from './Cell';
const Wrapper = ({ onPress, children }) => {
    const styles = useStyleSheet(getStyles);
    if (onPress) {
        return (React.createElement(Focusable, { style: styles.container, onPress: onPress, hoverStyle: styles.hover }, children));
    }
    return React.createElement(View, { style: styles.container }, children);
};
export const Row = ({ data, dimensions, minColumnWidth, cellTextStyle, alignment, onPress, selector, selected, onSelectChange }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(Wrapper, { onPress: onPress },
        selector ? (React.createElement(Checkbox, { style: styles.checkbox, onChange: onSelectChange, checked: selected !== null && selected !== void 0 ? selected : false })) : null,
        data.map((v, i) => (React.createElement(React.Fragment, { key: i },
            React.createElement(Cell, { data: v, style: [
                    Object.assign(Object.assign(Object.assign(Object.assign({ flex: dimensions[i] }, (minColumnWidth ? { flexBasis: minColumnWidth } : {})), (i === 0 ? { paddingLeft: 0 } : {})), (i === data.length - 1 ? { paddingRight: 0 } : {})), { alignItems: alignment[i] === 'right'
                            ? 'flex-end'
                            : alignment[i] === 'left'
                                ? 'flex-start'
                                : 'center' })
                ], textStyle: cellTextStyle }),
            i !== data.length - 1 && (React.createElement(Divider, { type: 'vertical', style: styles.divider })))))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: size.E,
        paddingHorizontal: size.E
    },
    divider: {
        height: size.J,
        alignSelf: 'center'
    },
    hover: {
        backgroundColor: color.invert2.p10
    },
    checkbox: { marginRight: size.G }
}));
//# sourceMappingURL=Row.js.map